import { render } from "./agencySlide5.vue?vue&type=template&id=3a6733ca&scoped=true"
import script from "./agencySlide5.vue?vue&type=script&lang=js"
export * from "./agencySlide5.vue?vue&type=script&lang=js"

import "./agencySlide5.vue?vue&type=style&index=0&id=3a6733ca&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a6733ca"]])

export default __exports__